/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Injectable({providedIn: 'root'})
export class AdnMessageParamsService {
  constructor(
    private readonly translate: TranslateService,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any
  ) {
  }

  private readonly paramTranslations: Record<string, (params: any, config?: any) => string> = {
    objectiveDeliveryPrediction: (params: any) => {
      // Avoid instant('lineItem.deliveryPrediction.' + null/undefined/'').
      if (params.objectiveDeliveryPrediction == null || params.objectiveDeliveryPrediction === '') {
        return '';
      }
      const key = 'lineItem.deliveryPrediction.' + params.objectiveDeliveryPrediction;
      return this.translate.instant(key).toLowerCase();
    },
    objectiveType: (params: any) => {
      if (params.objectiveType == null || params.objectiveType === '') {
        return '';
      }
      let key = 'lineItem.objective.' + params.objectiveType;
      if (parseInt(params.objectiveValue, 10) !== 1) {
        key += '.plural';
      }
      return this.LocalNetworkProfile.getNetworkTranslations(key) || this.translate.instant(key);
    },
    status: (params: any, config?: any) => {
      if (params.status == null || params.status === '') {
        return '';
      }
      const keyBase = config && config.status ? config.status : 'status';
      return this.translate.instant(keyBase + '.' + params.status).toLowerCase();
    },
    userState: (params: any) => {
      if (params.userState == null || params.userState === '') {
        return '';
      }
      return this.translate.instant('lineItem.userState.' + params.userState).toLowerCase();
    }
  };

  transform(message: any, config?: any): any {
    _.forEach(this.paramTranslations, (tx, param) => {
      if (_.has(message, ['params', param])) {
        message.params[param] = tx(message.params, config);
      }
      if (_.has(message, ['parameters', param])) {
        message.parameters[param] = tx(message.parameters, config);
      }
    });
    return message;
  }
}
